import firebase from 'firebase/compat/app';
import { Component } from 'react';
import { Button, FormControl, FormGroup } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import { withRouter } from 'react-router-dom';
import { auth } from '../../../../firebase';

import axios from 'axios';
import { BrowserView, MobileView } from 'react-device-detect';
import { Helmet } from 'react-helmet';
import LoadingOverlay from 'react-loading-overlay';
import { connect } from 'react-redux';
import RingLoader from 'react-spinners/RingLoader';
import swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import { default as config, CONSTANTS } from '../../../../constants/constants';
import apple from '../../../../images/apple.png';
import googleplus from '../../../../images/googleplus.png';
import { defaultRoute } from '../../../../session/default-route';
import VisitorMessagePanel from '../../../visitorMessagePanel/components/visitorMessagePanel';
import VisitorMessagePanelMobile from '../../../visitorMessagePanel/components/visitorMessagePanelMobile';
import Logo from '../../../../components/widgets/Logo';
import MobileFooter from '../../../../components/widgets/MobileFooter';
import InfloWelcome from '../InfloWelcome';
import '../../styles/login-inflo.css';
import RegisterInfloPage from '../register/RegisterInflo';
import AppstoreBanner from './AppstoreBanner';
import { updateIsFirstLogin } from '../../../../redux/actions/user-actions';

const INITIAL_STATE = {
  email: '',
  password: '',
  component: 'loginInflo',
  error: null,
  disabled: false,
  loading: false,
  forgotPassword: null,
  showPass: false,
  currentPanel: 'signin' // options: signin, forgotPassword, signinWithEmail
};

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

class LoginInfloPage extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  redirectToInfloWelcome = () => {
    this.setState({ component: 'infloWelcome' });
  };

  handleChangePanel = (panel = 'signin') => {
    this.setState({ currentPanel: panel });
  };

  handleInvitationCode = async (token, code, userStatus) => {
    const history = this.props.history;
    const data = { code };
    const options = {
      method: 'POST',
      headers: { 'X-Firebase-Auth': token },
      url: `${config.serverURL}/auth/invitation`,
      params: data
    };
    try {
      await axios(options);
      this.setState(byPropKey('loading', false));
      history.push(defaultRoute(userStatus));
    } catch (error) {
      if (error.response && error.response.data === 'The link is consumed') {
        swal({
          imageUrl: CONSTANTS.swalLogo,
          title:
            '<div class="titleModal">This link has already been used.</div>',
          html: '<p class="contentModal"></p>',
          showConfirmButton: false,
          showCloseButton: true,
          background: '#121C24',
          allowOutsideClick: false
        });
      }
      this.setState(byPropKey('loading', false));
      history.push(defaultRoute(userStatus));
    }
  };

  componentDidMount() {
    const url = new URL(window.location.href);
    const token = url.searchParams.get('token');
    if (token != null) {
      //sign in user with this token
      console.log('111111111111111111111111111111111111 ', token);
      firebase
        .auth()
        .signInWithCustomToken(token)
        .then((userCredential) => {
          // Signed in
          var user = userCredential.user;
          console.log('111111111111111111111111111111111111 ', user);
          // ...
        })
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log('111111111111111111111111111111111111 ', errorCode);
          console.log('111111111111111111111111111111111111 ', errorMessage);
          // ...
        });
    }
    const history = this.props.history;
    let code = this.props.match.params.code;

    this.listener = firebase.auth().onAuthStateChanged(async (authUser) => {
      if (authUser) {
        const idTokenResult = await authUser.getIdTokenResult();
        authUser.userStatus = await idTokenResult.claims.userStatus;
        authUser.subscriptionType = await idTokenResult.claims.subscriptionType;

        if (this.props.isFirstLogin) {
          localStorage.removeItem('infloFirstLogin');
          await this.props.dispatch(updateIsFirstLogin(false));
        }

        if (
          authUser.userStatus === undefined &&
          authUser.subscriptionType === undefined &&
          !code
        ) {
          return;
        }

        if (code !== undefined) {
          this.setState(byPropKey('loading', true));
          const token = await authUser.getIdToken();
          this.handleInvitationCode(token, code, authUser.userStatus);
        } else {
          const userStatus = authUser.userStatus || 'new';
          const subscriptionType = authUser.subscriptionType;

          history.push(defaultRoute(userStatus, subscriptionType));
        }
      }
    });
  }

  componentWillUnmount() {
    this.listener();
  }

  redirectToRegisterInflo = () => {
    this.setState({ component: 'registerInflo' });
  };

  logout = () => {
    firebase.auth.signOut().then(
      function() {
        this.props.history.push('/');
      },
      function() {}
    );
  };

  toggleShowHide = () => {
    this.setState({ showPass: !this.state.showPass });
  };

  handleEmailPasswordVerification = (currentUser) => {
    swal({
      imageUrl: CONSTANTS.swalLogo,
      title:
        '<div class="titleModal">We\'re sorry, your email<br />hasn\'t been verified yet.</div>',
      html:
        '<p class="contentModal">Please check your email (or spam) inbox<br />or click the button to receive a new verification email.</p>',
      showConfirmButton: true,
      confirmButtonText: 'Resend',
      showCloseButton: false,
      background: '#121C24',
      allowOutsideClick: false
    })
      .then((result) => {
        if (result) {
          this.setState({ disabled: false });
          currentUser.sendEmailVerification();
          return currentUser.getIdToken();
        }
      })
      .catch((error) => {
        console.error(error);
      });
    firebase.auth().signOut();
  };

  handleEmailPasswordError = (error) => {
    this.setState(byPropKey('error', error));
    this.setState(byPropKey('disabled', false));
    this.setState(byPropKey('loading', false));
    swal({
      imageUrl: CONSTANTS.swalLogo,
      title: '<div class="titleModal">We\'re sorry there was an error.</div>',
      html: `<p class="contentModal">${error.message}</p>`,
      showConfirmButton: false,
      showCloseButton: true,
      background: '#121C24',
      allowOutsideClick: false
    }).catch(swal.noop);
    firebase.auth().signOut();
  };

  onSubmit = async (event) => {
    event.preventDefault();
    this.setState(byPropKey('loading', true));
    this.setState(byPropKey('disabled', true));
    const { email, password } = this.state;

    try {
      const user = await auth.doSignInWithEmailAndPassword(email, password);
      const currentUser = firebase.auth().currentUser;
      if (currentUser.emailVerified) {
        if (currentUser.userStatus === undefined) {
          localStorage.setItem('infloFirstLogin', true);
          await this.props.dispatch(updateIsFirstLogin(true));
          this.props.history.push(defaultRoute('new'));
        }
        return currentUser.getIdToken();
      } else {
        //if not verified
        this.handleEmailPasswordVerification(currentUser);
      }
      this.setState(byPropKey('loading', false));
    } catch (error) {
      this.handleEmailPasswordError(error);
      this.setState(byPropKey('loading', false));
    }
  };

  updateEmailInDatabase = async (token, profileEmail) => {
    // update email in Database
    const options = {
      method: 'PUT',
      headers: { 'X-Firebase-Auth': token },
      url: `${config.serverURL}/subscriptions/updateemail?currentEmail=${profileEmail}`
    };
    return axios(options);
  };

  authUser = async (token) => {
    const options = {
      method: 'POST',
      headers: { 'X-Firebase-Auth': token },
      url: `${config.serverURL}/auth/user`
    };
    return axios(options);
  };

  handlePopSignInErrorWithToken = (error) => {
    const { setState } = this;
    setState(byPropKey('error', error));
    swal({
      imageUrl: CONSTANTS.swalLogo,
      title: '<div class="titleModal">We\'re sorry there was an error.</div>',
      html: `<p class="contentModal">${error.message}</p>`,
      showConfirmButton: false,
      showCloseButton: true,
      background: '#121C24',
      allowOutsideClick: false
    });
  };

  googleSignIn = async () => {
    const $this = this;
    var provider = new firebase.auth.GoogleAuthProvider();

    try {
      const result = await firebase.auth().signInWithPopup(provider);

      const profileEmail = result.additionalUserInfo.profile.email;
      const currentUser = firebase.auth().currentUser;
      if (!currentUser) throw new Error('User not found.');

      const currentEmail = currentUser.email;
      const shouldUpdateEmail = currentEmail && profileEmail !== currentEmail;

      try {
        const token = await firebase.auth().currentUser.getIdToken();
        await $this.authUser(token);
        await $this.updateEmailInDatabase(token, profileEmail);
      } catch (error) {
        $this.setState(byPropKey('loading', false));
        if (error.message.includes('403')) {
          currentUser.updateEmail(profileEmail);
        } else {
          $this.handlePopSignInErrorWithToken(error);
        }
      }
    } catch (error) {
      $this.setState(byPropKey('loading', false));
    }
  };

  facebookSignIn = () => {
    let currentUser;
    let token;
    const $this = this;

    var provider = new firebase.auth.FacebookAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function(result) {
        auth
          .doSignInAndRetrieveDataWithCredential(result.credential)
          .then(() => {
            currentUser = firebase.auth().currentUser;

            if (currentUser) {
              return currentUser.getIdToken();
            } else {
              return Promise.reject({ message: 'User not found' });
            }
          })
          .then((_token) => {
            token = _token;
            const options = {
              method: 'POST',
              headers: { 'X-Firebase-Auth': token },
              url: `${config.serverURL}/auth/user`
            };
            return axios(options);
          })
          .catch(function(error) {
            $this.setState(byPropKey('error', error));
            $this.setState(byPropKey('loading', false));
            swal({
              imageUrl: CONSTANTS.swalLogo,
              title:
                '<div class="titleModal">We\'re sorry there was an error.</div>',
              html: `<p class="contentModal">${error.message}</p>`,
              showConfirmButton: false,
              showCloseButton: true,
              background: '#121C24',
              allowOutsideClick: false
            }).catch(swal.noop);
          });
      })
      .catch(function(error) {
        $this.setState(byPropKey('loading', false));
        swal({
          imageUrl: CONSTANTS.swalLogo,
          title:
            '<div class="titleModal">We\'re sorry there was an error.</div>',
          html: `<p class="contentModal">${error.message}</p>`,
          showConfirmButton: false,
          showCloseButton: true,
          background: '#121C24',
          allowOutsideClick: false
        }).catch(swal.noop);
      });
  };

  appleSignIn = async () => {
    //this.setState(byPropKey('loading', true));
    const $this = this;

    var provider = new firebase.auth.OAuthProvider('apple.com');
    try {
      const result = firebase.auth().signInWithPopup(provider);
      const profileEmail = result.additionalUserInfo.profile.email;
      const currentUser = firebase.auth().currentUser;

      if (!currentUser) throw new Error('User not found.');

      const currentEmail = currentUser.email;
      const shouldUpdateEmail = currentEmail && profileEmail !== currentEmail;

      try {
        const token = await firebase.auth().currentUser.getIdToken();
        await $this.authUser(token);
        await $this.updateEmailInDatabase(token, profileEmail);
      } catch (error) {
        $this.setState(byPropKey('loading', false));
        if (error.message.includes('403')) {
          currentUser.updateEmail(profileEmail);
        } else {
          $this.handlePopSignInErrorWithToken(error);
        }
      }
    } catch (error) {
      $this.setState(byPropKey('loading', false));
    }
  };

  handleForgotPassword = (e) => {
    const { forgotPassword } = this.state;

    if (
      forgotPassword === null ||
      forgotPassword === undefined ||
      forgotPassword === ''
    ) {
      this.dialog.showAlert('Please insert an email.');
    } else {
      firebase
        .auth()
        .fetchSignInMethodsForEmail(forgotPassword)
        .then(function(result) {
          if (result[0] === 'password') {
            firebase
              .auth()
              .sendPasswordResetEmail(forgotPassword)
              .then(function() {
                swal({
                  imageUrl: CONSTANTS.swalLogo,
                  title:
                    '<div class="titleModal">Password Reset Email Sent</div>',
                  html:
                    '<p class="contentModal">Please check your email inbox to reset your password.</p>',
                  showConfirmButton: false,
                  showCloseButton: true,
                  background: '#121C24',
                  allowOutsideClick: false
                });
              })
              .catch(function(error) {
                if (error) {
                  if (error.code === 'auth/user-not-found') {
                    swal({
                      imageUrl: CONSTANTS.swalLogo,
                      title: '<div class="titleModal">Email not found.</div>',
                      html:
                        '<p class="contentModal">We\'re sorry, the user with this email does not exist.</p><p class="contentModal">Please try with another email.</p>',
                      showConfirmButton: false,
                      showCloseButton: true,
                      background: '#121C24',
                      allowOutsideClick: false
                    });
                  } else {
                    swal({
                      imageUrl: CONSTANTS.swalLogo,
                      title:
                        '<div class="titleModal">We\'re sorry there was an error.</div>',
                      html:
                        '<p class="contentModal">We\'ve encountered a problem. We are sorry for the inconvenience.</p><p class="contentModal">Please try again later or contact the Inflo support or your administrator.</p>',
                      showConfirmButton: false,
                      showCloseButton: true,
                      background: '#121C24',
                      allowOutsideClick: false
                    });
                  }
                }
              });
          } else {
            swal({
              imageUrl: CONSTANTS.swalLogo,
              title:
                '<div class="titleModal">Password reset not allowed.</div>',
              html: `<p class="contentModal">We're sorry, your ${result[0]} account does not allow you to change your password.</p>`,
              showConfirmButton: false,
              showCloseButton: true,
              background: '#121C24',
              allowOutsideClick: true
            });
          }
        });
    }
    e.preventDefault();
  };

  renderSignInPanel = (showCopyright = false) => {
    const { email, password, forgotPassword, loading } = this.state;

    const isInvalid =
      password === '' || email === '' || this.state.disabled === true;

    const isInvalid2 =
      forgotPassword === null ||
      forgotPassword === undefined ||
      forgotPassword === '';

    // let enterEmail;

    const enterEmail = () => {
      debugger;
      if (document.getElementById('forgotPassword')) {
        if (
          document.getElementById('forgotPassword').style.display === 'none'
        ) {
          document.getElementById('forgotPassword').style.display = 'block';

          var heightForm = document.getElementsByClassName('loginInfloForm')[0]
            .offsetHeight;
          var heightWindow = window.innerHeight;
          var widthWindow = window.innerWidth;

          if (heightWindow < heightForm) {
            if (widthWindow > 991) {
              document.getElementsByClassName(
                'loginInfloForm'
              )[0].style.maxHeight = heightWindow - 80 + 'px';
            } else {
              document.getElementsByClassName(
                'loginInfloForm'
              )[0].style.maxHeight = heightWindow - 30 + 'px';
            }
          }
        } else {
          document.getElementById('forgotPassword').style.display = 'none';
        }
      }
    };

    return (
      <>
        {this.state.currentPanel === 'signin' && (
          <form className="loginForm signinForm24" onSubmit={this.onSubmit}>
            <div className="form-group">
              <Button
                onClick={this.appleSignIn}
                className="buttonApple apple-btn button-oval button-signin24"
                style={{ marginTop: 24 }}
              >
                <img
                  src={apple}
                  height={20}
                  width={20}
                  alt="apple"
                  style={{ marginRight: 6, verticalAlign: 'text-bottom' }}
                />
                Sign in with Apple ID
              </Button>
              <div className="form-group">
                <Button
                  bsStyle="default"
                  onClick={this.googleSignIn}
                  className="google-btn button-oval button-signin24"
                >
                  <img
                    src={googleplus}
                    height={20}
                    width={20}
                    alt="google"
                    style={{ marginRight: 4, verticalAlign: 'bottom' }}
                  />{' '}
                  Sign in with Google
                </Button>
              </div>
            </div>
            <div
              class="c-horizontal_content_rule"
              style={{
                width: '70%',
                margin: 'auto',
                marginTop: 24,
                marginBottom: 24
              }}
            >
              <hr class="c-horizontal_content_rule__leftrule divider24" />
              <div class="c-horizontal_content_rule__content">or</div>
              <hr class="c-horizontal_content_rule__rightrule divider24" />
            </div>

            <div className="form-group">
              {/* <div style={{width: 300, height: 100, background: '#666464', paddingTop: 22}}>
            <button
              class="login-btn button-oval button-signin24 button-brand24 inflo24-gradient inflo24-play"
              onClick={() => {this.handleChangePanel('signinWithEmail')}}
              // type="submit"
              disabled={true}
              >
              (IF) Create Flag
            </button>
            </div> */}
              <button
                class="login-btn button-oval button-signin24 button-brand24 inflo24-gradient"
                onClick={() => {
                  this.handleChangePanel('signinWithEmail');
                }}
                // type="submit"
              >
                Sign in with Email
              </button>
            </div>
            <div className="other-links form-group">
              <div
                className="forgot-pass other-link"
                // onClick={enterEmail}
                onClick={() => {
                  this.handleChangePanel('forgotPassword');
                }}
                style={{ fontSize: 12 }}
              >
                Forgot password?
              </div>
              <hr className={'divider24'} />
              <div style={{ fontSize: 14 }}>New to Inflo?</div>
              <div
                className="new-acct other-link"
                onClick={this.redirectToRegisterInflo}
                style={{
                  textDecoration: 'underline',
                  fontSize: 14,
                  marginTop: 8
                }}
              >
                Create an account
              </div>
            </div>
          </form>
        )}
        {this.state.currentPanel === 'signinWithEmail' && (
          <form
            className="loginForm signinForm24"
            onSubmit={this.onSubmit}
            style={{ marginTop: 80 }}
          >
            <FormGroup controlId="email">
              <FormControl
                autofocous="true"
                componentClass="input"
                placeholder="Email"
                type="email"
                onChange={(event) =>
                  this.setState(byPropKey('email', event.target.value))
                }
                disabled={this.state.disabled}
                className="signIn-input24"
                style={{ display: 'inline' }}
              />
            </FormGroup>
            <FormGroup controlId="password">
              <FormControl
                componentClass="input"
                placeholder="Password"
                type={this.state.showPass ? 'text' : 'password'}
                onChange={(event) =>
                  this.setState(byPropKey('password', event.target.value))
                }
                disabled={this.state.disabled}
                className="signIn-input24"
                style={{ display: 'inline' }}
              />

              <i
                className={`fa ${
                  this.state.showPass ? 'fa-eye' : 'fa-eye-slash'
                } showHideIcon`}
                onClick={this.toggleShowHide}
                aria-hidden="true"
                title="Show/Hide Password"
              ></i>
            </FormGroup>
            <div className="form-group">
              <button
                class="login-btn button-oval button-signin24 button-brand24 inflo24-gradient "
                type="submit"
              >
                Sign In
              </button>
            </div>
            <div className="other-links form-group">
              <div
                className="forgot-pass other-link"
                // onClick={enterEmail}
                onClick={() => {
                  this.handleChangePanel('forgotPassword');
                }}
                style={{ fontSize: 12 }}
              >
                Forgot password?
              </div>
              <hr className={'divider24'} />
              <div
                className="new-acct other-link"
                onClick={() => {
                  this.handleChangePanel('signin');
                }}
                style={{ fontSize: 14 }}
              >
                Cancel
              </div>
            </div>
          </form>
        )}
        {this.state.currentPanel === 'forgotPassword' && (
          <div
            id="forgotPassword"
            style={{ width: '100%', textAlign: 'center' }}
          >
            <div
              style={{
                fontSize: 20,
                fontWeight: 400,
                marginTop: 72,
                marginBottom: 32
              }}
            >
              Forgot Your Password?
            </div>
            <form
              className="forgot-email"
              onSubmit={this.handleForgotPassword.bind(this)}
            >
              <FormGroup controlId="forgotPassword">
                <FormControl
                  componentClass="input"
                  placeholder="Email"
                  type="email"
                  onChange={(event) =>
                    this.setState(
                      byPropKey('forgotPassword', event.target.value)
                    )
                  }
                  className="signIn-input24"
                  style={{ display: 'inline', marginBottom: 18 }}
                />
              </FormGroup>
              <div className="form-group">
                <button
                  className="login-btn button-oval button-signin24 button-brand24 inflo24-gradient"
                  type="submit"
                  disabled={isInvalid2}
                >
                  Reset my Password
                </button>
              </div>
              <div
                className="forgot-pass other-link "
                // onClick={enterEmail}
                onClick={() => {
                  this.handleChangePanel('signin');
                }}
                style={{ fontSize: 12, marginTop: 72 }}
              >
                Back to Sign In
              </div>
            </form>
          </div>
        )}
        {showCopyright && (
          <div style={{ marginTop: 72 }}>
            <MobileFooter />
          </div>
        )}
      </>
    );
  };
  render() {
    const { loading } = this.state;

    if (
      this.state.component &&
      this.state.component !== 'registerInflo' &&
      this.state.component !== 'infloWelcome'
    ) {
      return (
        <div className="signInPanel">
          <MobileView viewClassName="mv mobile-signin-panel">
            <Helmet></Helmet>
            <LoadingOverlay
              active={loading}
              spinner={<RingLoader color={'orange'} />}
            >
              <Logo />
              <Dialog
                ref={(el) => {
                  this.dialog = el;
                }}
              />
              {this.renderSignInPanel(true)}
              <VisitorMessagePanelMobile />
            </LoadingOverlay>
          </MobileView>
          <BrowserView>
            <div>
              <AppstoreBanner />
              <LoadingOverlay active={loading} spinner>
                <div
                  className="paddingBlockInflo login-inflo-page"
                  style={{
                    background: `url(${CONSTANTS.heroImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'top center',
                    backgroundSize: 'cover'
                  }}
                >
                  <div className="browser-signin-panel">
                    <Logo />
                    <Dialog
                      ref={(el) => {
                        this.dialog = el;
                      }}
                    />
                    {this.renderSignInPanel()}
                    {this.state.currentPanel !== 'forgotPassword' &&
                      CONSTANTS.showEXIQ && (
                        <div className="footerInflo footerExIQ">
                          Inflo users&nbsp;
                          <div className="linkFooterInflo">
                            <div
                              style={{ textDecoration: 'underline' }}
                              onClick={this.redirectToInfloWelcome}
                            >
                              continue here »
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                  <VisitorMessagePanel />
                </div>
                <MobileFooter />
              </LoadingOverlay>
            </div>
          </BrowserView>
        </div>
      );
    } else if (
      this.state.component &&
      this.state.component === 'infloWelcome'
    ) {
      return <InfloWelcome />;
    } else {
      return <RegisterInfloPage />;
    }
  }
}

const mapStateToProps = (store) => {
  return {
    firebaseInfo: store.user.firebaseInfo,
    mysubscriptions: store.user.mysubscriptions,
    podcastUser: store.user.podcastUser,
    isFirstLogin: store.user.isFirstLogin
  };
};

export default withRouter(connect(mapStateToProps)(LoginInfloPage));
